import {Routes} from '@angular/router';
import {TaskManagerBoardListComponent} from './components/task-manager-board-list/task-manager-board-list.component';
import {TaskManagerBoardTileComponent} from './components/task-manager-board-tile/task-manager-board-tile.component';
import {TaskManagerKanbanComponent} from './components/task-manager-kanban/task-manager-kanban.component';
import {TaskManagerPersonalKanbanComponent} from './components/task-manager-kanban/task-manager-personal-kanban-component';
import {TaskManagerSupportKanbanComponent} from './components/task-manager-kanban/task-manager-support-kanban-component';
import {TaskManagerTicketListComponent} from './components/task-manager-ticket-list/task-manager-ticket-list.component';
import {TaskManagerPersonalListComponent} from './components/task-manager-ticket-list/task-manager-personal-list-component';
import {TaskManagerSupportListComponent} from './components/task-manager-ticket-list/task-manager-support-list-component';
import {PlatformLinkCreatorComponent} from '@shared/components/platform-tool/platform-link-creator/platform-link-creator.component';
import {AuthGuard} from '@core/services/auth-guard.service';
import { MentionedActivitiesComponent } from './collaboration/components/ActivityTracker/mentioned-activities/mentioned-activities.component';
import {ActivityGotoResolverComponent} from '@features/task-manager/collaboration/components/ActivityTracker/activity-goto-resolver/activity-goto-resolver.component';


export const taskManagerRoutes: Routes = [
  {
    path     : 'task-manager/card',
    component: TaskManagerBoardTileComponent
  },
  {
    path     : 'task-manager/grid',
    component: TaskManagerBoardListComponent
  },
  {
    path     : 'task-manager/team/card/:id',
    component: TaskManagerKanbanComponent
  },
  {
    path     : 'task-manager/personal/card/:id',
    component: TaskManagerPersonalKanbanComponent
  },
  // {
  //   path     : 'task-manager/support/card',
  //   component: TaskManagerSupportKanbanComponent
  // },
  {
    path     : 'task-manager/team/card/:id/:taskId',
    component: TaskManagerKanbanComponent
  },
  {
    path     : 'task-manager/personal/card/:taskId',
    component: TaskManagerPersonalKanbanComponent
  },
  // {
  //   path     : 'task-manager/support/card/:taskId',
  //   component: TaskManagerSupportKanbanComponent
  // },
  {
    path     : 'task-manager/team/grid/:id',
    component: TaskManagerTicketListComponent
  },
  {
    path     : 'task-manager/personal/grid/:id',
    component: TaskManagerPersonalListComponent
  },
  // {
  //   path     : 'task-manager/support/grid',
  //   component: TaskManagerSupportListComponent
  // },
  {
    path     : 'task-manager/team/grid/:id/:taskId',
    component: TaskManagerTicketListComponent
  },
  {
    path     : 'task-manager/personal/grid/:taskId',
    component: TaskManagerPersonalListComponent
  },
  // {
  //   path     : 'task-manager/support/grid/:taskId',
  //   component: TaskManagerSupportListComponent
  // },
  {
    path: 'activities/:type/:id',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/entitycount',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/detached-sub-accounts',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/hubspot-report',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-feedback',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-article',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-unresolved',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-active-trial',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-expired-trial',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-licensed-users',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/xatbot-cancelled-users',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report/eat-usage-report-by-company',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'administration/usage-report/eat-usage-report-by-company/:CompanyId',
    component: PlatformLinkCreatorComponent
  },
  {
    path: 'administration/usage-report-old/demo/by-user',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  // {
  //   path: 'task-manager/support/grid',
  //   component: PlatformLinkCreatorComponent,
  // },
  // {
  //   path: 'task-manager/support/card',
  //   component: PlatformLinkCreatorComponent,
  // },
  {
    path: 'administration/usage-report-old/by-user',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activities',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activity-goto-resolver',
    component: ActivityGotoResolverComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/demo',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/demo/by-feature',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-feature',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/sandbox',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-feature/:FeatureId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-company/:RowId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-article/:ArticleId',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-article',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/demo/by-article',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-newsletter',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/by-newsletter',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'administration/usage-report-old/demo/by-demo',
    component: PlatformLinkCreatorComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'activities/my-mentioning',
    component: MentionedActivitiesComponent,
    canActivate: [AuthGuard]
  },

];
